var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Fail_report"},[_c('Navbar'),_c('v-container',{staticClass:"grey lighten-5"},[_c('Transfail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }